export default __webpack_public_path__ + "static/media/HalfCircle3.16bb0531.svg";